import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { ContactIdContainer, IDButton } from "./ContactId.styled";
import {
  DivBackgroundLowOpacity,
  DivBackgroundFullOpacity,
} from "../../RelatedContactList.styled";
import AddEditRelatedContact from "../../../AddEditRelatedContact/AddEditRelatedContact";

const ContactId = (props) => {
  const {
    t,
    data,
    id,
    status,
    updateRefeshStatus,
    relatedContactId,
    type,
    entityId,
    entityType,
    contactStatus,
    countryId,
  } = props;
  const [isEditMode, setIsEditMode] = useState(false);
  const [isViewMode, setIsViewMode] = useState(true);
  const [isEditContactPopupVisible, setIsEditContactPopupVisible] =
    useState(false);

  const onContactIdClick = () => {
    setIsEditContactPopupVisible(true);
  };

  const closeContactEditPopup = () => {
    setIsEditMode(false);
    setIsViewMode(true);
    setIsEditContactPopupVisible(false);
  };

  const togglePopUp = () => {
    setIsEditMode(!isEditMode);
    setIsViewMode(!isViewMode);
  };

  return (
    <>
      {!!status && (
        <DivBackgroundFullOpacity>
          <ContactIdContainer>
            <IDButton onClick={onContactIdClick}>{data}</IDButton>
          </ContactIdContainer>
        </DivBackgroundFullOpacity>
      )}
      {!status && (
        <DivBackgroundLowOpacity>
          <ContactIdContainer>
            <IDButton onClick={onContactIdClick}>{data}</IDButton>
          </ContactIdContainer>
        </DivBackgroundLowOpacity>
      )}
      {isEditContactPopupVisible && (
        <AddEditRelatedContact
          id={relatedContactId}
          title={t("CONTACT") + " #" + id}
          onClose={closeContactEditPopup}
          isEditMode={isEditMode}
          isViewMode={isViewMode}
          togglePopUp={togglePopUp}
          updateRefeshStatus={updateRefeshStatus}
          entityType={entityType}
          entityId={entityId}
          contactStatus={contactStatus}
          countryId={countryId}
        />
      )}
    </>
  );
};

ContactId.propTypes = {
  t: PropTypes.func.isRequired,
  contactStatus: PropTypes.number,
};

ContactId.defaultProps = {
  contactStatus: null,
};
export default withTranslation()(ContactId);
